/*
 * @Description: 商品分组管理
 * @Author: AI Assistant
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState } from 'react';
import { Icon, Button, Table, Loading, Input } from '@alifd/next';
import styles from './index.module.scss';
import SelectSku from './SelectSku';
import LzMsg from '@/components/common/LzMsg';
import utils from '@/common/utils';
import LzDialog from '@/components/common/LzDialog';
import { Servlets } from '@/service';
import ConfirmDialog from '@/components/Dialog/ConfirmDialog';

let failSku = 0;
const GoodsGroupManage = (): JSX.Element => {
  // loading
  const [isLoading, setLoading] = useState(false);
  const [skus, setSkus] = useState<any[]>([]); // 全部sku
  const [selectSkuIds, setSelectSkuIds] = useState<string[]>([]); // 已选skuId
  const [selectSku, setSelectSku] = useState<any[]>([]); // 已选择商品
  const [importSku, setImportSku] = useState<any[]>([]); // 导入商品
  const [dialogFlag, setDialogFlag] = useState(0); // 所有弹窗 0 为关闭   1为新建或修改 2为详情  3 为删除确认弹窗
  const [pageSkuInfo, setPageSkuInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  }); // 检索条件的hook
  const [conditions, setConditions] = useState({
    skuIds: '',
  });
  const [formData, setFormData] = useState({
    productLineName: '',
    productLineDes: '',
    productLineLv: 0,
    productLineType: '',
  });
  // 商品分组List
  const [productLineList, setProductLineList] = useState<any[]>([]);
  // 删除或修改的商品分组id
  const [removeId, setRemoveId] = useState('');
  // 查看商品分组详情
  const [productDetail, setDroductDetail] = useState<Record<string, any>>({});
  // 商品分组筛选数据
  const [productFilter, setProductFilter] = useState({
    name: '',
    productLineType: '',
  });

  // tab切换
  const changeTabProduct = (num: string): void => {
    if (num === '1-1') {
      searchSku({
        pageNo: 1,
        pageSize: 10,
      });
    } else {
      setSkus([]);
    }
  };

  // 搜索商品
  const searchSku = (p?: Record<string, any>): void => {
    setLoading(true);
    if (p?.type === 1) {
      // Servlets('importGoodsSku', {
      // 先用get因为后端没写post，接口列表列的post是假的，后端根本没开发
      Servlets('getGoodsSku', {
        ...conditions,
        ...p,
        pageSize: 100000,
        pageNo: 1,
      }).then((res: any) => {
        if (!res.success) {
          LzMsg.error(res.resp_msg || '导入商品失败');
          setLoading(false);
        } else {
          const { data } = res;
          // 导入商品
          const dataSIds = data.filter((c: any) => {
            return selectSkuIds.indexOf(c.skuId) < 0;
          });
          setSelectSku([...selectSku, ...dataSIds]);
          setImportSku(data);
          const o = p.skuIds
            .replace(/[\r\n]/g, ',')
            .split(',')
            .filter((c: string) => {
              return c !== '';
            });
          failSku = o.length - data.length;
          setLoading(false);
        }
      }).catch(() => {
        LzMsg.error('导入商品请求异常');
        setLoading(false);
      });
    } else {
       Servlets('getGoodsSku', {
        pageSize: p?.pageSize || pageSkuInfo.pageSize,
        pageNo: p?.pageNo || pageSkuInfo.pageNo,
        ...conditions,
        ...p,
      }).then((res: any) => {
        if (!res.success) {
          LzMsg.error(res.resp_msg || '获取商品列表失败');
        } else {
          setSkus(res.data);
          setPageSkuInfo(res.page);
        }
        setLoading(false);
      }).catch(() => {
        LzMsg.error('获取商品请求异常');
        setLoading(false);
      });
    }
  };

  // 重置
  const reset = async (): Promise<void> => {
    setConditions({ skuIds: '' });
    await searchSku({ skuIds: '', pageSize: 10, pageNo: 1 });
  };

  // 关闭弹窗
  const onCloseActive = (): void => {
    setDialogFlag(0);
  };

  // 新建商品分组提交
  const saveTable = async (): Promise<void> => {
    if (!formData.productLineName) {
      parent.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      LzMsg.error('请输入商品分组名称');
      return;
    }
    if (!selectSku.length) {
      parent.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      LzMsg.error('请选择商品');
      return;
    }
    const skuIdLists = selectSku.map((e: any) => e.skuId);
    setSelectSkuIds(skuIdLists);
    setDialogFlag(0);
    setImportSku([]);
    setPageSkuInfo({ pageNo: 1, pageSize: 10, total: 0 });
    setLoading(true);
    if (removeId) {
      try {
        await Servlets('updataProduct', {
          ...formData,
          id: removeId,
          skus: skuIdLists.join(','),
        });
        setLoading(false);
        parent.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        LzMsg.success('修改成功');
        getProductLine();
        setRemoveId('');
      } catch (err) {
        setLoading(false);
        setRemoveId('');
      }
    } else {
      try {
        await Servlets('addNewProduct',{
          ...formData,
          skus: skuIdLists.join(','),
        });
        setLoading(false);
        parent.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        LzMsg.success('新建成功');
        getProductLine('');
      } catch (err) {
        getProductLine('');
        setLoading(false);
      }
    }
  };

  // 新建商品分组按钮
  const addProductBt = (): void => {
    setRemoveId('');
    setDialogFlag(1);
    searchSku();
    setFormData({ productLineName: '', productLineDes: '', productLineLv: 0, productLineType: '' });
    setSelectSkuIds([]);
    setSelectSku([]);
    setConditions({ skuIds: '' });
    setImportSku([]);
    failSku = 0;
  };

  // 获取商品分组列表
  const getProductLine = (val?: Record<string, any>): void => {
    setLoading(true);
    Servlets('getProductLineList',{
      pageNo: 1,
      pageSize: 35,
      ...val,
    })
      .then((result: any) => {
        setLoading(false);
        setProductLineList(result.data);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // 删除商品分组
  const deleteProductBt = (): void => {
    setLoading(true);
    Servlets('deleteProductLine', { id: removeId })
      .then((result: any) => {
        setLoading(false);
        parent.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        LzMsg.success(result.data ? '删除成功' : '删除失败');
        setDialogFlag(0);
        getProductLine('');
        setRemoveId('');
      })
      .catch(() => {
        setLoading(false);
        setDialogFlag(0);
        setRemoveId('');
      });
  };

  // 修改商品分组
  const changePruductLine = (item: any): void => {
    failSku = 0;
    setImportSku([]);
    setSelectSkuIds(item.skus);
    setRemoveId(item.id);
    searchSku();
    setDialogFlag(1);
    setFormData({
      productLineName: item.productLineName,
      productLineDes: item.productLineDes,
      productLineLv: item.productLineLv,
      productLineType: item.productLineType,
    });
    Servlets('getGoodsSku', {
      pageSize: 300,
      pageNo: 1,
      skuIds: item.skus,
    }).then((res: any) => {
      if (res.success) {
        setSelectSku(res.data || []);
      }
    });
  };

  // 重置商品分组筛选数据
  const resetProduct = (): void => {
    setProductFilter({ name: '', productLineType: '' });
  };

  useEffect(() => {
    utils.setBreadcrumb({ name: '商品分组管理' });
    getProductLine('');
  }, []);

  // skus
  useEffect(() => {
    const skuIds = selectSku.map((sku: any) => sku.skuId);
    setSelectSkuIds(skuIds);
  }, [selectSku]);

  return (
    <Loading visible={isLoading} fullScreen>
      <div className={styles.pageContainer}>
        <section className={styles.productList_box}>
          <section className={styles.filterData}>
            <span className={styles.mr15}>商品分组名称：</span>
            <Input
              className={styles.w240}
              value={productFilter.name}
              onChange={(name: string) => { setProductFilter({ ...productFilter, name }); }}
              placeholder="请输入"
            />
            <span className={`${styles.mr15} ${styles.filterLabelGap}`}>商品分组类型：</span>
            <Input
              className={styles.w240}
              value={productFilter.productLineType}
              onChange={(productLineType: string) => { setProductFilter({ ...productFilter, productLineType }); }}
              placeholder="请输入"
            />
            <Button
              className={`${styles.mr10} ${styles.w88} ${styles.ml20}`}
              type="primary"
              onClick={() => getProductLine(productFilter)}
            >
              查询
            </Button>
            <Button
              className={styles.w88}
              type="normal"
              onClick={() => { resetProduct(); getProductLine({}); }}
            >
              重置
            </Button>
          </section>

          <div className={styles.add_box}>
            <div className={styles.addBoxIcon}>
              <span className="iconfont icon-yemianzhuangxiuicon-08" />
            </div>
            <div className={styles.addBoxText}>新建商品分组</div>
            <Button
              className={styles.addBoxBtn}
              disabled={productLineList.length >= 35}
              type="secondary"
              onClick={() => addProductBt()}
            >
              开始创建
            </Button>
          </div>

          {productLineList.map((item: any) => (
            <div key={item.id} className={styles.product_box}>
              <div className={styles.product_box_top}>
                <div className={styles.product_box_left}>
                  <div className={styles.productTitleRow}>
                    <span className={styles.productIcon}>
                      <span className="iconfont icon-icon5-21" />
                    </span>
                    <div title={item.productLineName} className={styles.productNameText}>
                      {item.productLineName}
                    </div>
                  </div>
                  <div title={item.productLineDes} className={styles.product_des}>
                    {item.productLineDes}
                  </div>
                  <div
                    title={`商品分组类型/级别：${item.productLineType}/${item.productLineLv || 0}级`}
                    className={`${styles.product_name} ${styles.productTypeLevel}`}
                  >
                    商品分组类型/级别：{item.productLineType}/{item.productLineLv || 0}级
                  </div>
                  <Button
                    className={`${styles.detailBtn} table-cell-btn`}
                    type="primary"
                    text
                    onClick={() => { setDroductDetail(item); setDialogFlag(2); }}
                  >
                    查看详情信息
                  </Button>
                </div>
                <div className={styles.product_box_right}>
                  <div className={styles.skuCountNum}>{item.skuNumber}</div>
                  <div className={styles.skuCountLabel}>商品分组包含SKU数</div>
                </div>
              </div>
              <div className={styles.actionArea}>
                <Button className={styles.mr10} type="secondary" onClick={() => changePruductLine(item)}>
                  修改商品分组
                </Button>
                <Button type="normal" onClick={() => { setRemoveId(item.id); setDialogFlag(3); }}>
                  删除商品分组
                </Button>
              </div>
            </div>
          ))}
        </section>

        {/* 新建/编辑商品分组弹窗 */}
        <LzDialog
          className={styles.dialogSkuTable}
          title="新建商品分组"
          footer={false}
          isFullScreen
          visible={dialogFlag === 1}
          shouldUpdatePosition
          onClose={() => setDialogFlag(0)}
        >
          <div>
            <SelectSku
              skus={skus}
              selectSku={selectSku}
              importSku={importSku}
              failSku={failSku}
              importSkuTip="最多可选择300个商品"
              supportSku={300}
              changeTabProduct={changeTabProduct}
              searchSku={searchSku}
              pageSkuInfo={pageSkuInfo}
              setConditions={setConditions}
              conditions={conditions}
              reset={reset}
              selectSkuIds={selectSkuIds}
              onCloseActive={onCloseActive}
              saveTable={saveTable}
              setSelectSku={setSelectSku}
              setFormData={setFormData}
              formData={formData}
            />
          </div>
        </LzDialog>

        {/* 删除商品分组二次确认 */}
        <ConfirmDialog
          type="WARN"
          title="提示"
          promptInfo="是否确认删除？"
          flag={dialogFlag === 3}
          confirmHandel={() => deleteProductBt()}
          cancelHandel={() => { setRemoveId(''); setDialogFlag(0); }}
        />

        {/* 查看商品分组信息 */}
        <LzDialog
          footer={false}
          className={styles.detailDialog}
          title="查看商品分组信息"
          shouldUpdatePosition
          visible={dialogFlag === 2}
          onClose={() => setDialogFlag(0)}
        >
          <div className={styles.dialogContent}>
            <div className={styles.detailText}>
              商品分组名称：{productDetail.productLineName}
            </div>
            <div
              className={`${styles.detailText} ${styles.mt20}`}
              style={{
                display: 'flex',
                width: '100%'
              }}
            >
              <div
                style={{
                  whiteSpace:'nowrap'
                }}
              >SKU列表：</div>
              <div>
                <div className={styles.skuText}>{productDetail.skus}</div>
                <Button
                  type="secondary"
                  className="submit-btn"
                  onClick={() => {
                    utils.copyText(productDetail.skus);
                    parent.scrollTo(0, 0);
                    document.documentElement.scrollTop = 0;
                    LzMsg.success('复制成功');
                  }}
                >
                  复制
                </Button>
              </div>
            </div>
          </div>
          <hr />
          <div className={styles.dialogFooter}>
            <Button type="normal" className="cancel-btn" onClick={() => setDialogFlag(0)}>
              关闭
            </Button>
          </div>
        </LzDialog>
      </div>
    </Loading>
  );
};

export default GoodsGroupManage;
